// Version 2.0.0
// Added input blocker for special characters

(function() {
    const changePopupText = () => {
        const targetNode = document.body;

        const observer = new MutationObserver((mutationsList, obs) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                const title = document.querySelector('#swal2-title')
                const el = document.querySelector("#swal2-html-container");
                if (el && el.textContent.includes("Please read and confirm the agreement")) {
                    el.textContent = 'Before you can add your monogrammed bag to the cart, you need to check the box acknowledging it is a final sale.'
                    title.textContent = 'One More Step'
                    obs.disconnect();
                }
            }
        }
        });

        observer.observe(targetNode, {
            childList: true,
            subtree: true
        });
    }

    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
        changePopupText()
    })

    
    const SEL = 'textarea[maxlength="1"], input[maxlength="1"]';
    const isTarget = (el) => el && el.matches && el.matches(SEL);

    // =========== FORCE 0-9 A-Z only =====================
    document.addEventListener('input', (e) => {
        const el = e.target;
        if (!isTarget(el)) return;
        // remove any non-alphanumeric character right away
        const clean = el.value.replace(/[^A-Za-z0-9]/g, '');
        if (clean !== el.value) {
            el.value = clean;
        }
    }, true);
    // =========== /FORCE 0-9 A-Z only ====================

    // On focus, select existing char so the next key replaces it
    document.addEventListener('focusin', (e) => {
        const el = e.target;
        if (!isTarget(el)) return;
        el.dataset._justFocused = '1';
        // Delay to let the app finish focusing
        setTimeout(() => { try { el.select(); } catch {} }, 0);
    }, true);
    // Prevent the first mouseup from clearing the selection made on focus
    document.addEventListener('mouseup', (e) => {
        const el = e.target;
        if (!isTarget(el)) return;
        if (el.dataset._justFocused === '1') {
        e.preventDefault();
        try { el.select(); } catch {}
        el.dataset._justFocused = '';
        }
    }, true);
    // Before printable input, ensure the whole value is selected (so default typing replaces it)
    document.addEventListener('keydown', (e) => {
        const el = e.target;
        if (!isTarget(el)) return;
        // Let Tab/Shift+Tab and Backspace/Delete behave normally
        if (e.key === 'Tab' || e.key === 'Backspace' || e.key === 'Delete') return;
        // For printable keys, select-all if caret is collapsed
        if (e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
        try {
            const len = el.value.length;
            if (len > 0 && el.selectionStart === el.selectionEnd) {
            el.setSelectionRange(0, len);
            }
        } catch {}
        // Do NOT preventDefault — let the browser insert text
        }
    }, true);
    // Safety: enforce single-char if something tries to insert more (e.g., paste)
    document.addEventListener('input', (e) => {
        const el = e.target;
        if (!isTarget(el)) return;
        if (el.value && el.value.length > 1) {
        const v = (e.data && e.data.slice(-1)) || el.value.slice(-1);
        el.value = v.toUpperCase();
        // EDIT UPPERCASE 5.7
        // no manual event dispatch; the native input/change flow is already happening
        }
    }, true);

    // ============== FORCE TEXTAREA TO UPPERCASE ON EXIT (quiet + loop-safe) ==============
        const DEBUG = false;
        const log = (...args) => { if (DEBUG) console.log('[UpperOnExit]', ...args); };
        const processing = new WeakSet();

        const forceUpperOnExit = (el) => {
        if (!(el instanceof HTMLTextAreaElement)) return;
        if (!el.value) { log('No value, skipping.'); return; }
        if (processing.has(el)) { log('Already processing, skip.'); return; }

        processing.add(el);
        log('Scheduling uppercase. Current value:', el.value);

        // Delay so lib finalizes its own updates first
        setTimeout(() => {
            const upper = el.value.toUpperCase();

            // Use native setter so React/CPB sees it
            const proto = HTMLTextAreaElement.prototype;
            const desc = Object.getOwnPropertyDescriptor(proto, 'value');
            if (desc && desc.set) {
            desc.set.call(el, upper);
            log('Set via native setter:', el.value);
            } else {
            el.value = upper;
            log('Set via direct property (fallback):', el.value);
            }
            // Optional attribute sync
            try { el.setAttribute('value', upper); } catch {}
            // Notify framework once
            el.dispatchEvent(new Event('input', { bubbles: true }));
            log('Dispatched input event.');
            processing.delete(el);
        }, 150);
        };
        // single listener; avoid blur/change 2 reduce echoes
        document.addEventListener('focusout', (e) => {
        const el = e.target;
        if (!(el instanceof HTMLTextAreaElement)) return;
        log('Event: focusout on', el);
        forceUpperOnExit(el);
        }, true);
    // ============== /FORCE TEXTAREA TO UPPERCASE ON EXIT =================================

    
})()